/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_line_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste your data to build a line chart instantly. Use a first column for the x-axis labels and one or more numeric columns for the lines; a header row names each line.`)
};

const es_line_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega tus datos para crear un gráfico de líneas al instante. Usa una primera columna para las etiquetas del eje X y una o más columnas numéricas para las líneas; una fila de cabecera nombra cada línea.`)
};

const de_line_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fügen Sie Ihre Daten ein, um sofort ein Liniendiagramm zu erstellen. Verwenden Sie eine erste Spalte für die x-Achsen-Beschriftungen und eine oder mehrere numerische Spalten für die Linien; eine Kopfzeile benennt jede Linie.`)
};

const nl_line_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak je data om direct een lijndiagram te bouwen. Gebruik een eerste kolom voor de x-as-labels en een of meer numerieke kolommen voor de lijnen; een headerrij benoemt elke lijn.`)
};

const fr_line_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez vos données pour créer instantanément un graphique en courbes. Utilisez une première colonne pour les étiquettes de l'axe des x et une ou plusieurs colonnes numériques pour les courbes ; une ligne d'en-tête nomme chaque courbe.`)
};

const it_line_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla i tuoi dati per costruire istantaneamente un grafico a linee. Usa una prima colonna per le etichette dell'asse x e una o più colonne numeriche per le linee; una riga di intestazione nomina ciascuna linea.`)
};

const pt_br2_line_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole seus dados para criar um gráfico de linhas instantaneamente. Use uma primeira coluna para os rótulos do eixo x e uma ou mais colunas numéricas para as linhas; uma linha de cabeçalho nomeia cada linha.`)
};

const pt_line_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole os seus dados para construir um gráfico de linhas instantaneamente. Use uma primeira coluna para os rótulos do eixo X e uma ou mais colunas numéricas para as linhas; uma linha de cabeçalho nomeia cada linha.`)
};

const ja_line_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`データを貼り付けると即座に折れ線グラフが作成されます。最初の列をx軸ラベルに、1つ以上の数値列を線に使用してください。ヘッダー行で各線に名前を付けられます。`)
};

const zh_line_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴数据即可立即生成折线图。第一列用于 x 轴标签，一列或多列数值用于绘制线条；表头行为每条线命名。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const line_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.line_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("line_intro", locale)
	if (locale === "en") return en_line_intro(inputs)
	if (locale === "es") return es_line_intro(inputs)
	if (locale === "de") return de_line_intro(inputs)
	if (locale === "nl") return nl_line_intro(inputs)
	if (locale === "fr") return fr_line_intro(inputs)
	if (locale === "it") return it_line_intro(inputs)
	if (locale === "pt-BR") return pt_br2_line_intro(inputs)
	if (locale === "pt") return pt_line_intro(inputs)
	if (locale === "ja") return ja_line_intro(inputs)
	return zh_line_intro(inputs)
};